<div class="container">
  <div class="row" infinite-scroll infiniteScrollDistance="1" infiniteScrollThrottle="300" (scrolled)="expand()">
    <div class="col-sm-12 col-md-12">
      <ng-container *ngIf="!loading">

        <h1>{{ 'orderhistory.order' | translate}} {{ orderHistoryItem.ordernumber }}</h1>

        <p class="subheader">
          {{ 'orderhistory.requesteddlvdate'| translate }} {{ requestedDeliveryDate }}
        </p>

        <!--<button (click)="goBack()" class="btn btn-success" tabindex="-1"><i class="fa fa-arrow-left"></i>{{ 'details.back-button' | translate }}</button>-->

        <div class="ordertable">

          <div class="heading">
            <div class="column column-width-40">{{ 'orders.product' | translate }}</div>
            <div class="column column-width-10">{{ 'order.quantity' | translate }}</div>
            <div class="column column-width-10">{{ 'order.unit' | translate }}</div>
            <div class="column column-width-10">{{ 'order.pieces-abbrev' | translate }}</div>
            <div class="column column-width-10">{{ 'order.price' | translate }}</div>
            <div class="column column-width-10">{{ 'order.total-line-price' | translate }}</div>
          </div>

          <div class="data">

            <app-orderhistorylines-line
              *ngFor="let line of orderHistoryLines"
              [line]="line"
              [isInCart]="isInCart(line)"
              [isReOrderable]="isReOrderable(line)"
              [currency]="currency"
              (onReOrder)="reOrder($event)">
            </app-orderhistorylines-line>

          </div>
        </div>
      </ng-container>

      <app-products-loader
        [loading]="loading || expanding"
        [viewType]="'list-view'"
        [size]="'small'"
        [productsCount]="8">
      </app-products-loader>

      <div class="orderhistorylines-footer text-right">
        {{ 'order.order-total' | translate }}: {{ orderHistoryItem.totalPrice | price: currency }}
      </div>

      <div class="row-back">
            <button (click)="goBack()" class="btn btn-back" tabindex="-1"><i class="fa fa-arrow-left"></i>{{ 'details.back-button' | translate }}</button>
      </div>
    </div>
  </div>
</div>
